import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

const bgColors = {
  success: '#CEF1CA',
  warning: '#F7E6CC',
  error: '#bd362f',
  info: '#73D2DE'
}

const closeColors = {
  warning: '../../../assets/icons/icons-toast/close_warning.svg',
  success: '../../../assets/icons/icons-toast/close_success.svg',
  info: '../../../assets/icons/icons-toast/close_info.svg'
}

const titleColors = {
  warning: '#B4752C',
  success: '#3D8F3D',
  info: '#000'
}

const iconsAlert = {
  warning: '../../../assets/icons/icons-toast/warning.svg',
  success: '../../../assets/icons/icons-toast/success.svg',
  info: '../../../assets/icons/icons-toast/info.svg'
}

const bgIcon = {
  success: 'mnf-ok',
  error: 'mnf-close',
  warning: 'mnf-info',
  info: 'mnf-info'
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'notyf-toast-component',
  styles: [`
    .toast-fixed-l  {
      top: 15px;
      right: 10px;
    }
    .close-button {
      background: none;
      border: none;
      font-size: 15px;
      cursor: pointer;
      color: #000;
      position: absolute;
      top: 2px;
      right: 8px;
      padding: 0;
      z-index: 9999;
      width: 10px;
      height: 10px;
    }
    .new-toast {
      border-radius: 7px;
      max-width: 439px;
      margin-bottom: 10px;
      font-size: 12px;
    }
    .close-button img {
      width: 100%;
      height: 100%;
    }
    @media screen and (max-width: 600px) {
      .toast-fixed-l  {
        top: 8px;
        right: 0px;
        max-width: 300px;
      }
    }
    @media screen and (min-width: 601px) and (max-width: 1200px) {
      .toast-fixed-l  {
        top: 25px;
        right: 5px;
      }
    }
  `],
  template: `
    <div class="toast-fixed-l new-toast notyf__toast notyf__toast notyf__toast--{{type}}" style="background-color: {{backGroundColor}};">
      <div class="notyf__wrapper">
      <div class="notyf__icon">
          <img [src]="iconsAlert" alt="">
        </div>
        <div class="notyf__message cl-black">
          <strong style="color: {{titleColors}}">{{ title }}</strong> {{ message }}
        </div>
      </div>
      <div
        class="notyf__ripple"
        style="background-color: {{backGroundColor}}"
      ></div>
      <button (click)="removeAlert()" class="close-button">
        <img [src]="closeColors" alt="Cerrar" />
      </button>
    </div>
  `,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      transition(
        'inactive => active',
        animate(
          '300ms ease-out',
          keyframes([
            style({
              opacity: 0,
              bottom: '-15px',
              'max-height': 0,
              'max-width': 0,
              'margin-top': 0,
            }),
            style({
              opacity: 0.8,
              bottom: '-3px',
            }),
            style({
              opacity: 1,
              bottom: '0',
              'max-height': '200px',
              'margin-top': '12px',
              'max-width': '400px',
            }),
          ]),
        ),
      ),
      state(
        'active',
        style({
          bottom: '0',
          'max-height': '200px',
          'margin-top': '12px',
          'max-width': '400px',
        }),
      ),
      transition(
        'active => removed',
        animate(
          '300ms ease-out',
          keyframes([
            style({
              opacity: 1,
              transform: 'translateY(0)'
            }),
            style({
              opacity: 0,
              transform: 'translateY(25%)'
            }),
          ]),
        ),
      ),
    ]),
  ],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class NotyfToast extends Toast {
  type: string;
  backGroundColor: string;
  closeColors: string;
  titleColors: string;
  iconsAlert: string;
  icon: string;

  constructor(
    protected override toastrService: ToastrService,
    public override toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
    this.type = this.toastPackage.toastType.split('-')[1];
    this.backGroundColor = bgColors[this.type];
    this.closeColors = closeColors[this.type];
    this.titleColors = titleColors[this.type];
    this.iconsAlert = iconsAlert[this.type];
    this.icon = bgIcon[this.type];
  }

  removeAlert() {
    this.toastrService.remove(this.toastPackage.toastId);
  }

}